import React from "react";
import styled from "styled-components";

import SearchClose from "./icons/SearchClose";

const Container = styled.div`
  position: relative;
  z-index: 7;
  color: ${props => props.theme.text};
  @media (max-width: 575px) {
    z-index: 3;
  }
`;

const InnerContainer = styled.div`
  position: absolute;
  width: 98%;
  @media (max-width: 575px) {
    width: 100%;
    background-color: ${props => props.theme.background};
    height: fill-available;
  }
`;

const InputWrapper = styled.div`
  display: grid;
  grid-template-columns: 0 1fr;
  width: 55%;
  margin: 30px auto;

  @media (max-width: 575px) {
    display: none;
  }
  @media (min-width: 1800px) {
    margin: 70px auto 30px;
    width: 51%;
  }
`;

const ResultWrapper = styled.div`
  width: 55%;
  margin: 30px auto;
  background-color: ${props => props.theme.background};
  border-radius: 33px;
  padding: 16px 25px;
  box-sizing: border-box;

  @media (max-width: 575px) {
    width: 100%;
    margin-top: 0;
  }

  @media (min-width: 1800px) {
    width: 51%;
    padding: 23.5px 32.6px;
  }
`;

const InputField = styled.input`
  direction: rtl;
  background-color: ${props => props.theme.primary};
  border: 1px solid ${props => props.theme.primary};
  padding: 5px 25px 5px 50px;
  box-sizing: border-box;
  height: 50px;
  border-radius: 50px;
  outline: none;
  color: ${props => props.theme.white};
  text-align: right;
  font-size: 20px;
  font-family: "dubai-regular";
  padding-left: 40px;

  @media (min-width: 1800px) {
    height: 75px;
    font-size: 30px;
  }
`;

const Icon = styled.i`
  width: 40px;
  position: relative;
  left: 20px;
  top: 17.5px;
  cursor: pointer;
  z-index: 1;
  @media (min-width: 1800px) {
    top: 27px;
    left: 30px;
  }
`;

const List = styled.ul`
  font-size: 15px;
  line-height: 25px;
  text-align: right;
  list-style: none;
  cursor: pointer;
  padding: 0;
  li {
    padding: 2px 0;
  }

  li:hover {
    color: ${props => props.theme.textHighlight};
  }
  @media (max-width: 575px) {
    font-size: 14px;
    line-height: 24px;
    li {
      margin: 9px 0;
    }
  }

  @media (min-width: 1800px) {
    font-size: 21px;
    line-height: 36px;
  }
`;

const RadioButtons = styled.div`
  text-align: right;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`;

const Option = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
`;

const Label = styled.label`
  font-size: 12px;
  font-family: "dubai-bold";
  cursor: pointer;

  @media (max-width: 575px) {
    font-size: 10px;
  }
`;

const RadioInput = styled.input`
  :checked,
  :not(:checked) {
    position: absolute;
    left: -9999px;
  }
  :checked + label,
  :not(:checked) + label {
    position: relative;
    padding-right: 22px;

    @media (min-width: 1800px) {
      padding-right: 30px;
      font-size: 18px;
    }
    @media (max-width: 575px) {
      padding-right: 15px;
    }
  }
  :checked + label:before,
  :not(:checked) + label:before {
    content: "";
    position: absolute;
    right: 0;
    top: 2px;
    width: 10px;
    height: 10px;
    border: 1px solid ${props => props.theme.text};
    border-radius: 100%;
    background: none;
    @media (min-width: 1800px) {
      width: 14px;
      height: 14px;
      border: 2px solid ${props => props.theme.text};
      top: 0;
    }
    @media (max-width: 575px) {
      width: 8px;
      height: 8px;
    }
  }
  :checked + label:after,
  :not(:checked) + label:after {
    content: "";
    width: 11px;
    height: 11px;
    position: absolute;
    top: 2px;
    right: 0px;
    background: ${props => props.theme.textHighlight};

    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    @media (min-width: 1800px) {
      width: 16px;
      height: 16px;
      top: 1px;
      right: 1px;
    }

    @media (max-width: 575px) {
      width: 10px;
      height: 10px;
    }
  }
  :not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  :checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
`;

const result = [
  "تصريح  الفعاليات الاهلية والاعلانات",
  "اصدار تصريح عمل مؤقت",
  "الغاء تصريح عمل مؤقت",
  "طلب إصدار تصريح إعلان على الموبي/ أعمدة الإنارة",
  "تعديل بيانات تصريح عمل مؤقت",
  "طلب إصدار تصريح إعلان جداري على واجهة المبنى/ أسماء البنايات والأبراج"
];

const SearchArea = ({ open, onClose }) => {
  return open ? (
    <Container>
      <InnerContainer>
        <InputWrapper>
          <Icon>
            <SearchClose onClick={onClose} />
          </Icon>
          <InputField autoFocus type="text" />
        </InputWrapper>
        <ResultWrapper>
          <RadioButtons>
            <Option>
              <RadioInput name="search-filter" type="radio" id="filter-1" />
              <Label htmlFor="filter-1">(20) جهات</Label>
            </Option>
            <Option>
              <RadioInput name="search-filter" type="radio" id="filter-2" />
              <Label htmlFor="filter-2">(120) خدمات </Label>
            </Option>
            <Option>
              <RadioInput name="search-filter" type="radio" id="filter-3" />
              <Label htmlFor="filter-3">(15) مراكز خدمة </Label>
            </Option>
            <Option>
              <RadioInput name="search-filter" type="radio" id="filter-4" />
              <Label htmlFor="filter-4">(16) قنوات </Label>
            </Option>
          </RadioButtons>
          <List>
            {result.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </List>
        </ResultWrapper>
      </InnerContainer>
    </Container>
  ) : (
    ""
  );
};

export default SearchArea;
